import * as pdfjsLib from 'pdfjs-dist';

export function setupPdfJsWorker(): void {
    pdfjsLib.GlobalWorkerOptions.workerSrc =
        `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
}
